import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowSplitUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-split-up, rules, direction, split"} maskId="square-filled-radius-0-stroke-1-IconArrowSplitUp"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H10V4H4.70711L12 11.2929L19.2929 4H14V3H21V10H20V4.70711L12.5 12.2071V21H11.5V12.2071L4 4.70711V10H3V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowSplitUp;
